module.exports = __webpack_public_path__ + "img/btn_TA_pressed.bfb5b102.png";